export const IRIS_ALLY_LABELS = {
    ButtonId: {
        BANK_LIST: 'iris-button-bank-list',
        QR_CODE: 'iris-button-qrCode'
    },
    AreaId: {
        BANK_LIST: 'iris-area-bank-list',
        QR_CODE: 'iris-area-qrCode'
    }
};

export const DEFAULT_IRIS_COUNTDOWN_TIME = 10;
